import { render, staticRenderFns } from "./OrderDetailsTable.vue?vue&type=template&id=27437037&"
import script from "./OrderDetailsTable.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports